import controlConfig from "@/components/controls/index.js";

// 集合在form组件里的，和项目有关的控件配置表
window.controlConfig = controlConfig;

// 请求接口地址的配置
const params = require("../config/index.js");
const developmentSocketUrl = params.dev.proxyTable["/api"].target;
window.config = {
    amapKey: "f4f0c1cfd4f138648319fb9df109bf1c",
    host: process.env.NODE_ENV === "development" ? developmentSocketUrl : "/api",
    env: process.env.NODE_ENV,
    apiUrl: "/api",
    socketUrl: process.env.NODE_ENV === "development" ? developmentSocketUrl : (process.env.NODE_ENV === "newstaging" ? "http://47.94.146.184:6006" : (process.env.NODE_ENV === "production" ? "http://39.97.211.251:6006" : window.location.origin))
};



// WEBPACK FOOTER //
// ./src/window.js